import React from 'react';
import Modal from '../Modal';
import { RowSecurity } from './rowForm';

/**
 * Row-level security of one table, read only (DESIGN_EDITING.md E30): whether it is forced, and each policy as Postgres
 * keeps it. The expressions are the customer's own SQL text, rendered as text. A policy is changed with a SQL statement.
 */
const RowSecurityModal: React.FC<{ table: string; rls: RowSecurity; onClose: () => void }> = ({ table, rls, onClose }) => (
    <Modal isOpen onClose={onClose} title="Row-level security" size="md">
        <div className="db-data-form db-data-rls">
            <p className="db-data-related-where">
                <strong>{table}</strong> · {rls.forced ? 'forced: the table owner is held to it too' : 'not forced: the table owner skips it'}
            </p>
            {rls.policies.length === 0 ? (
                <p className="db-data-field-line">No policies: only roles that skip row-level security see or change rows.</p>
            ) : (
                <ul className="db-data-rls-list">
                    {rls.policies.map((p) => (
                        <li key={p.name}>
                            <div className="db-data-rls-head">
                                <strong>{p.name}</strong>
                                <span>{p.command} · {p.permissive ? 'permissive' : 'restrictive'} · {p.roles.join(', ') || 'public'}</span>
                            </div>
                            {p.using !== null && <div className="db-data-rls-expr"><span>using</span><code>{p.using}</code></div>}
                            {p.check !== null && <div className="db-data-rls-expr"><span>with check</span><code>{p.check}</code></div>}
                        </li>
                    ))}
                </ul>
            )}
            <div className="modal-actions">
                <button type="button" className="cancel-button" onClick={onClose}>Close</button>
            </div>
        </div>
    </Modal>
);

export default RowSecurityModal;
